import { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Button, LoadingTable } from '../../components/base';
import { ConfirmModal } from '../../components/common/ConfirmModal';
import { DataTable, IDataTableColumn } from '../../components/common/DataTable';
import { BlockCard, PageBody, PageContainer, PageHeader } from '../../components/container';
import { BaseShowDetail } from '../../context/base/BaseShowDetail';
import { eBaseActionStatus } from '../../context/base/eBaseActionStatus';
import { actions } from '../../context/stores/rootActions';
import { AppState } from '../../context/stores/rootReducers';
import { CollectionModel } from '../../context/models/collections/CollectionModel';
import { CollectionActionTypes } from '../../context/stores/collections/ICollectionActionsTypes';
import CollectionDetail from './CollectionDetail';
import { no_img } from '../../components/shared/hoc-static';
// import { useLookupCollectionGroup } from '../../components/shared/hoc-collection-group/useLookupCollectionGroup';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { CollectionResponse } from '../../context/models/collections/CollectionResponse';
import ComboBoxCollectionGroup from '../../components/shared/hoc-collection-group/ComboBoxCollectionGroup';
import { useLookupCollectionGroup } from '../../components/shared/hoc-collection-group/useLookupCollectionGroup';
type ICollectionPageProps = {
	titlePage: string;
	status: eBaseActionStatus;
	current_group_id:number;
	allCollections: CollectionResponse[];
	selectedIds: number[];
	showDetail: BaseShowDetail<CollectionModel>;
	showConfirm: boolean;
	handleReloadAllData: (group_id:number) => void;
	handleSaveData: (data: CollectionModel) => void;
	handleDeleteData: (data: number[]) => void;
	onChangeSelectedIds: (ids: number[]) => void;
	onShowDetail: (data: BaseShowDetail<CollectionModel>) => void;
	onShowConfirm: (isShow: boolean) => void;
};

const mapStateToProps = (state: AppState) => {
	return {
		titlePage: `vị trí`,
		status: state.collection.status,
		current_group_id: parseInt(localStorage.getItem('current_group_id') || '1'),
		allCollections: state.collection.allCollections,
		selectedIds: state.collection.selectedIds,
		showDetail: state.collection.showDetail,
		showConfirm: state.collection.showConfirm,
	};
};

const mapDispatchToProps = (dispatch: Dispatch<CollectionActionTypes>) => ({
	handleReloadAllData: (groupID: number) => {
		dispatch(actions.collection.getAllRequest({groupID}));
	},
	handleSaveData: (data: CollectionModel) => {
		dispatch(actions.collection.saveRequest(data));
	},
	handleDeleteData: (ids: number[]) => {
		dispatch(actions.collection.deleteRequest(ids));
	},
	onChangeSelectedIds: (ids: number[]) => {
		dispatch(actions.collection.changeSelectedIds(ids));
	},
	onShowDetail: (data: BaseShowDetail<CollectionModel>) => {
		dispatch(actions.collection.showDetail(data));
	},
	onShowConfirm: (isShow: boolean) => {
		dispatch(actions.collection.showConfirm(isShow));
	},
});

const CollectionPage = (props: ICollectionPageProps) => {
	const navigate = useNavigate();
	const {
		titlePage,
		status,
		selectedIds,
		showConfirm,
		showDetail,
		allCollections,
		handleReloadAllData,
		handleDeleteData,
		onChangeSelectedIds,
		handleSaveData,
		onShowDetail,
		onShowConfirm,
		current_group_id,
	} = props;
	allCollections.sort((a, b) => a.stt - b.stt);

	// const handleAddEditAction = (data: CollectionItemRequest) => {
	// 	navigate(`/collections-item`, { replace: true });
	// };

	const { collection_group_all } = useLookupCollectionGroup();

	const [groupID, setGroupID] = useState<number>(current_group_id);

	var handleReloadData = useCallback(() => {
		handleReloadAllData(groupID);
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [groupID]);

	useEffect(() => {
		handleReloadData();
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [groupID]);

	useEffect(() => {
		if (status === eBaseActionStatus.reload) handleReloadData();
		//eslint-disable-next-line react-hooks/exhaustive-deps
	}, [status]);

	const columns = useMemo((): IDataTableColumn<any>[] => {
		return [
			{ accessorKey: 'stt', header: 'Số thứ tự', size: 100, meta: { align: 'center' } },
			{ accessorKey: 'name', header: 'Tên bộ sưu tâp', size: 150 },
			{ accessorKey: 'slug', header: 'Slug', minSize: 150 },
			{
				accessorKey: 'collectionGroupId',
				header: 'Vị trí',
				size: 150,
				cell: ({ getValue }) => {
					const val = getValue() as number;
					const group = collection_group_all.find((g: any) => g.id === val);
					return <span className='font-medium'>{group ? group.name : val}</span>;
				}
			},
			{ accessorKey: 'description', header: 'Mô tả', size: 150 },
			{
				accessorKey: 'image',
				header: 'Ảnh',
				size: 150,
				cell: ({ row }) => {
					const picture = row.original;
					return (
						<div className='flex items-center gap-2'>
							<div className='hidden md:flex flex-shrink-0 w-12 h-12 rounded-md border border-border/50 bg-background overflow-hidden items-center justify-center shadow-sm'>
								<img src={picture.image?.length > 0 ? picture.image : no_img} alt='ảnh' className='object-cover w-full h-full rounded-sm' />
							</div>
						</div>
					);
				}
			},
			{
				accessorKey: 'icon',
				header: 'Icon',
				size: 150,
				cell: ({ row }) => {
					const picture = row.original;
					return (
						<div className='flex items-center gap-2'>
							<div className='hidden md:flex flex-shrink-0 w-12 h-12 rounded-md border border-border/50 bg-background overflow-hidden items-center justify-center shadow-sm'>
								<img src={picture.icon?.length > 0 ? picture.icon : no_img} alt='Icon' className='object-cover w-full h-full rounded-sm' />
							</div>
						</div>
					);
				}
			},
			{ accessorKey: 'link', header: 'Link', size: 150 },
			{
				id: 'actions',
				header: 'Sửa',
				meta: { align: 'center' },
				size: 100,
				cell: ({ row }) => {
					return row.original.id > 0 ? (
						<div className="flex gap-2 justify-center">
							<Button
								onClick={() => {
									localStorage.setItem('current_collection_id', String(row.original.id));
									navigate(`/collections-item`, { replace: true });
								}}
								text=''
								icon='ni ni-grid-box-alt-fill'
								preset='dimoutline'
								theme='info'
								title='Từ khóa thuộc bộ sưu tập'
							/>
							<Button
								onClick={() => onShowDetail({ isShow: true, detailData: row.original })}
								text=''
								icon='ni ni-edit'
								preset='dimoutline'
								theme='primary'
								title='Sửa'
							/>
						</div>
					) : null;
				}
			}
		];
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [collection_group_all, navigate, onShowDetail]);

	return (
		<>
			<PageContainer>
				<PageHeader title={`Danh sách ${titlePage}`}>
					<div className='flex flex-wrap items-center justify-end'>
						<ul className='flex flex-wrap items-center gap-2 [&>li]:list-none'>
							{selectedIds.length > 0 && (
								<li>
									<Button
										text={`Xóa (${selectedIds.length})`}
										icon='icon ni ni-trash'
										className='hidden md:inline-flex'
										theme='danger'
										onClick={() => onShowConfirm(true)}
									/>
								</li>
							)}

							<li>
								<Button
									text='Tạo mới'
									icon='icon ni ni-plus'
									theme='primary'
									className='hidden md:inline-flex'
									onClick={() => onShowDetail({ isShow: true })}
								/>
							</li>
						</ul>
					</div>
				</PageHeader>
				<PageBody>
					<BlockCard>
						{status === eBaseActionStatus.loading && <LoadingTable />}
						{status !== eBaseActionStatus.loading && (
							<DataTable
								data={allCollections}
								columns={columns}
								isLoading={status !== eBaseActionStatus.complete}
								enableRowSelection
								rowSelection={selectedIds.reduce((acc, id) => ({ ...acc, [String(id)]: true }), {})}
								onRowSelectionChange={(selection) => {
									onChangeSelectedIds(Object.keys(selection).filter(k => selection[k]).map(Number));
								}}
								enablePagination
								totalRecords={allCollections.length}
								enableGlobalFilter={false}
								toolbar={{
									isShowSearch: false,
									extraActions: (
										<div className="w-[300px]">
											<ComboBoxCollectionGroup
												name={'groupID'}
												onValueChanged={(value) => {
													setGroupID(value ? parseInt(value) : 0);
												}}
												value={groupID}
												placeholder='Nhập bộ sưu tập...'
												sizeClass='sm'
											/>
										</div>
									)
								}}
								onRefresh={handleReloadData}
							/>
						)}
					</BlockCard>
				</PageBody>
			</PageContainer>
			{showDetail && showDetail.isShow && (
				<>
					<CollectionDetail
						isSaving={status === eBaseActionStatus.saving}
						isShow={showDetail.isShow}
						detailModel={showDetail.detailData}
						onClose={() => onShowDetail({ isShow: false })}
						onSubmit={(data) => handleSaveData(data)}
						title={`${showDetail.detailData ? `Cập nhật` : `Thêm mới`} ${titlePage}`}
					/>
				</>
			)}
			{showConfirm && (
				<>
					<ConfirmModal
						show={showConfirm}
						innerText={`Bạn chắc chắn muốn xóa ${selectedIds.length} ${titlePage.toLowerCase()} đã chọn ?`}
						type='danger'
						onClose={() => onShowConfirm(false)}
						onConfirmed={() => handleDeleteData(selectedIds)}
						isLoading={status === eBaseActionStatus.loading || status === eBaseActionStatus.saving}
						btnConfirmText='Xóa'
						btnCloseText='Không xóa'
					/>
				</>
			)}
		</>
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionPage);
